import { UserRole } from "@next-platform/packages-ts-types";
import { useTranslation } from "../../localization/hooks";
import { SubscriptionTiers, UserRoles } from "../types";
/**
 * Maps a user role to its translated, user-facing User Plan name.
 *
 * Display only. Platform Tier logic (capability gating, banner segments,
 * analytics, experiment targeting) must keep using the pure
 * `getSubscriptionTier` utility, which returns a stable enum rather than a
 * localized label.
 */
const useUserPlanName = (role) => {
    const { t } = useTranslation();
    switch (role) {
        case UserRoles.PREMIUM:
            return t("subscription:tier.paid_premium");
        case UserRole.SM_PREMIUM:
            return t("subscription:tier.sm_premium");
        case UserRoles.BASIC:
            return t("subscription:tier.paid_basic");
        case UserRole.SM_BASIC:
            return t("subscription:tier.sm_basic");
        case UserRoles.MINIMAL:
            return t("subscription:tier.paid_minimal");
        default:
            return SubscriptionTiers.FREE;
    }
};
export default useUserPlanName;
